<template>
  <div class="fluid-xs leading-tightest space-y-2">
    <div v-for="item in deliveryDetails" :key="item.id" class="flex items-center justify-between leading-none py-px">
      <span class="inline-flex items-center">
        {{ item.label }}
        <Popover v-if="item.hasTooltip" class="inline-block -my-2">
          <template #button>
            <div class="size-6 flex items-center justify-center">
              <InfoSolidIcon class="w-[14px] text-gray-light" />
            </div>
          </template>

          <div class="text-copy w-full whitespace-nowrap" v-html="item.tooltipContent"></div>
        </Popover>
      </span>
      <span v-if="hasFreeShipping && item.valueWithFreeShipping" class="text-br-green font-medium"
        >{{ item.valueWithFreeShipping }}
      </span>
      <span v-else class="text-br-green font-medium">{{ item.valueDefault }}</span>
    </div>
  </div>
</template>

<script>
import InfoSolidIcon from '@/components/icons/InfoSolidIcon.vue';
import Popover from '@/components/Popover';
import { useCartSettingsStore } from '@/stores/cart-settings';
import { useCartStore } from '@/stores/cart';
import { storeToRefs } from 'pinia';

export default defineNuxtComponent({
  components: {
    InfoSolidIcon,
    Popover,
  },

  setup() {
    const cartSettingsStore = useCartSettingsStore();
    const cartStore = useCartStore();

    const { shippingEntry, deliveryDetails } = storeToRefs(cartSettingsStore);
    const { hasFreeShipping } = storeToRefs(cartStore);

    return {
      shippingEntry,
      deliveryDetails,
      hasFreeShipping,
    };
  },
});
</script>
